export {selectQuoteTypeLocalization} from "./selectQuoteTypeLocalization"
export {getInfoString} from "./getInfoString"
export {getCallBackPrompt} from "./getCallBackPrompt"